import { createContext, PropsWithChildren, SetStateAction, useState } from 'react';
import Overlay from '../Generic/overlay';

const noop = () => {};

const overlayContextDefaults = {
   text: '',
   showWith: noop as (_text: SetStateAction<string>) => void,
   overlayOpacity: 0,
   duration: 300,
   setDuration: noop as (_duration: SetStateAction<number>) => void,
};

const OverlayContext = createContext(overlayContextDefaults);

/* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
function OverlayProvider({ children }: PropsWithChildren<{}>) {
   const [overlayOpacity, setOverlayOpacity] = useState(0);
   const [text, setText] = useState('');
   const [duration, setDuration] = useState(300);

   const showWith = (text: SetStateAction<string>) => {
      if (!text) {
         return;
      }
      // fade in - then out
      setText(text);
      setOverlayOpacity(1);
      setTimeout(() => {
         setOverlayOpacity(0);
      }, duration);
   };

   const overlayContext = {
      text,
      overlayOpacity,
      duration,
      setDuration,
      showWith,
   };

   return (
      <OverlayContext.Provider value={overlayContext}>
         <Overlay text={text} opacity={overlayOpacity} />
         {children}
      </OverlayContext.Provider>
   );
}

export { OverlayProvider, OverlayContext };
